<template>
  <div>
    <b-row>
      <b-col md="6" xl="6">
        <b-input-group :prepend="$t('shared.title')" class="mb-2">
          <b-form-input dir="auto" v-model="widgetTitle"/>
        </b-input-group>
      </b-col>

      <b-col md="6" xl="6">
        <b-input-group :prepend="$t('widgetAreas.subtitle')" class="mb-2">
          <b-form-input dir="auto" v-model="widgetSubtitle"/>
        </b-input-group>
      </b-col>

      <b-col md="6" xl="3">
        <b-input-group :prepend="$t('widgetAreas.url')" class="mb-2">
          <b-form-input dir="ltr" placeholder="http(s)://" v-model="widgetUrl"/>
        </b-input-group>
      </b-col>

      <b-col md="6" xl="3">
        <b-input-group :prepend="$t('widgetAreas.widgetAvailability')" class="mb-2">
          <b-form-select v-model="widgetAvailability" :options="availabilityOptions"/>
        </b-input-group>
      </b-col>

      <b-col md="6" xl="3">
        <b-input-group :prepend="$t('shared.viewData')" class="mb-2">
          <b-form-input dir="auto" v-model="widgetViewData"/>
        </b-input-group>
      </b-col>
      
      <b-col md="6" xl="3">
        <b-input-group :prepend="$t('widgetAreas.view')" class="mb-2">
          <b-form-input dir="auto" v-model="widgetView"/>
        </b-input-group>
      </b-col>
    </b-row>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'widget',
  inject: ['$validator'],
  props: {
    type: {type: String, required: true},
    title: {type: String},
    subtitle: {type: String},
    url: {type: String},
    availability: {type: String, required: true},
    viewData: {type: String},
    view: {type: String}
  },
  data () {
    return {
      widgetType: this.type,
      widgetTitle: this.title,
      widgetSubtitle: this.subtitle,
      widgetUrl: this.url,
      widgetOpen: this.open,
      widgetAvailability: this.availability,
      availabilityOptions: [
        { value: 'everyone', text: this.$t('widgetAreas.everyone') },
        { value: 'authenticated', text: this.$t('widgetAreas.authenticated') },
        { value: 'unauthenticated', text: this.$t('widgetAreas.unauthenticated') }
      ],
      widgetViewData: this.viewData,
      widgetView: this.view
    }
  },
  watch: {
    widgetType (val) { this.$emit('update:type', val) },
    widgetTitle (val) { this.$emit('update:title', val) },
    widgetSubtitle (val) { this.$emit('update:subtitle', val) },
    widgetUrl (val) { this.$emit('update:url', val) },
    widgetAvailability (val) { this.$emit('update:availability', val) },
    widgetViewData (val) { this.$emit('update:viewData', val) },
    widgetView (val) { this.$emit('update:view', val) }
  }
}
</script>
